import * as React from "react";
import { withStyles, WithStyles, Theme, withTheme, WithTheme, createStyles } from "../mui/styles";
import classNames from 'classnames';
import DataGridHeaderCell from "./DataGridHeaderCell";
import { TableRow } from "../widget";
import { HeaderColumn, DataGridLines, DataGridPadding } from "./Types";
import { StyleRulesCallback } from "@material-ui/core";

export interface DataGridHeaderRowProps {
    columns: HeaderColumn[];
    gridLines?: DataGridLines;
    padding?: DataGridPadding;
}

declare type Props = DataGridHeaderRowProps & WithStyles<typeof styles>;

class DataGridHeaderRow extends React.PureComponent<Props> {
    render() {
        const { classes, columns, gridLines, padding } = this.props;

        const rowClassName = classNames({
            [classes.root]: true,
            [classes.padding]: padding && padding !== 'default',
        })

        return <TableRow className={rowClassName}>
            {columns.map((c, k) => <DataGridHeaderCell key={k} {...c} firstCol={k === 0} gridLines={gridLines} padding={padding} />)}
        </TableRow>;
    }
    // <TableRow key={k}>{hrw.map((c, k) => <DataTableHeaderCell key={k} {...c} padding={padding} />)}</TableRow>
}

const styles = ((theme: Theme) => {

    return createStyles({

        root: {
        },

        padding: {
            height: 0,
        },
    })
}) as StyleRulesCallback;

export default withStyles(styles, { name: 'DataGridHeaderRow' })(DataGridHeaderRow);
